import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { colors, typography } from '#themes/stena-recycling';
import { Paragraph } from '#components/Typography/Paragraph';

export const styles = {
  Container: ({ fullWidth }: { fullWidth: boolean }) => css`
    max-width: ${fullWidth ? 'none' : '28rem'};
    display: flex;
    flex-direction: column;
    gap: 0.25rem;

    ${
      fullWidth &&
      css`
        /* Takes its parent's width, so a long selected label truncates instead of widening the parent. */
        contain: inline-size;
        min-width: 12rem;
      `
    }
  `,
  FieldLabelCss: css`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    font-size: ${typography.other.inputLabel.fontSize};
    line-height: ${typography.other.inputLabel.lineHeight};
    font-weight: ${typography.other.inputLabel.fontWeight};
    color: ${colors.primary.grey};
    position: relative;
  `,
};

export const Description = styled(Paragraph)`
  font-size: ${typography.body.medium.fontSize};
  line-height: ${typography.body.medium.lineHeight};
  font-weight: 500;
  color: ${colors.primary.grey};
`;

export const ErrorMessage = styled(Paragraph)`
  font-size: ${typography.body.medium.fontSize};
  line-height: ${typography.body.medium.lineHeight};
  color: ${colors.alerts.error};
`;
